import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import ReservationTable from './ReservationTable';

const ReservationSearch = () => {
  const [emailQuery, setEmailQuery] = useState('');
  const [lastNameQuery, setLastNameQuery] = useState('');
  const [bookingIdQuery, setBookingIdQuery] = useState('');

  return (
    <div className="p-6 h-screen">
      {/* Title Section */}
      <div className="text-center mb-4">
        <div className="inline-block">
          <h1 className="text-2xl font-semibold">Hotel Management Reservation</h1>

          <h1 className="text-xs font-light font-poppins text-gray-900">
            The Hotel Management Reservation System efficiently streamlines booking, guest
            information tracking, and room allocation for seamless hotel operations and enhanced
            customer service.
          </h1>
          <hr className="border-gray-400 mt-1  w-96 mx-auto" />
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className="flex space-x-3 px-5 mb-1">
        {/* Search by Email */}
        <div className="relative flex-1">
          <input
            type="text"
            placeholder="Search by Email"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md shadow-sm "
            value={emailQuery}
            onChange={(e) => setEmailQuery(e.target.value)}
          />
          <FaSearch className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
        </div>

        {/* Search by Last Name */}
        <div className="relative flex-1">
          <input
            type="text"
            placeholder="Search by Last Name"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md shadow-sm "
            value={lastNameQuery}
            onChange={(e) => setLastNameQuery(e.target.value)}
          />
          <FaSearch className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
        </div>

        {/* Search by Booking ID */}
        <div className="relative flex-1">
          <input
            type="text"
            placeholder="Search by Booking ID"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md shadow-sm "
            value={bookingIdQuery}
            onChange={(e) => setBookingIdQuery(e.target.value)}
          />
          <FaSearch className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
        </div>
      </div>

      {/* Table Section */}
      <ReservationTable
        emailQuery={emailQuery}
        lastNameQuery={lastNameQuery}
        bookingIdQuery={bookingIdQuery}
      />
    </div>
  );
};

export default ReservationSearch;
